import { render, staticRenderFns } from "./MeasurementsList.vue?vue&type=template&id=55dfd7f2"
import script from "./MeasurementsList.vue?vue&type=script&lang=js"
export * from "./MeasurementsList.vue?vue&type=script&lang=js"
import style0 from "./MeasurementsList.vue?vue&type=style&index=0&id=55dfd7f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports